import cn from 'classnames'
import { useCallback, useMemo, useRef, useState } from 'react'

import { useOnScreen } from '../../hooks/useOnScreen'
import OptionButton from '../OptionButton'

import './style.css'

const limitOptionsCount = 3

const OptionsContainer = ({ options = [], isLoading }) => {
  const optionsEndRef = useRef(null)
  const isOptionsEndOnScreen = useOnScreen(optionsEndRef)
  const hasMoreThanLimitOptionsCount = useMemo(() => {
    return options.length > limitOptionsCount
  }, [options.length])
  const [maxHeight, setMaxHeight] = useState(0)

  const optionsContainerRefCallback = useCallback((node) => {
    if(node) {
      const firstChild = node.children[0]
      const height = firstChild.offsetHeight
      const marginBottom = +getComputedStyle(firstChild).marginBottom.replace('px', '')
      const totalHeight = marginBottom + height
      setMaxHeight(totalHeight * options.length)
    }
  }, [options.length])

  return <div ref={optionsContainerRefCallback} className={cn("relative px-4 overflow-y-auto inline-block justify-end h-full", {
    'app-options-container': hasMoreThanLimitOptionsCount
  })}
    style={{
      maxHeight: hasMoreThanLimitOptionsCount ? undefined : maxHeight,
      minHeight: hasMoreThanLimitOptionsCount ? undefined : maxHeight,
    }}>
    {options.map((option) => (
      <div key={option.name} className="mb-4">
        <OptionButton
          key={option.name}
          name={option.name}
          imageUrl={option.image}
          options={option.options}
          onClick={() => option.onClick && option.onClick(option)}
          disabled={isLoading}
        />
      </div>
    ))}
    <div className="-mt-1" ref={optionsEndRef} />
    <div className={cn('sticky bottom-0 w-full bg-black app-options-container-blur', {
      'hidden': isOptionsEndOnScreen || !hasMoreThanLimitOptionsCount,
    })} />
  </div>
}

export default OptionsContainer
